import {  IntervalObservable  } from './IntervalObservable';

export const interval = IntervalObservable.create;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/interval.ts